<div *ngIf="isLoading" class="loading-spinner">
    <mat-spinner></mat-spinner>
</div>

<ng-container *ngIf="!isLoading">

    <div class="detail-cell-renderer">
        <div>
            <h1 class="grid-item" style="margin-bottom: 0; text-align:center; background-color: rgb(22, 3, 3);color: #fdfdfd;">{{this.contact_organization}}
            </h1>
        </div>         
        <mat-tab-group>
            <mat-tab label="Addresses"><br>
                <div style="text-align:right;" *ngIf="!addressExists">
                    <div style="align-items: center; justify-content: center;">
                        <button mat-raised-button style=" background-color: rgb(35, 24, 134);color: #fdfdfd;" (click)="addAddress()">&nbsp;<i class="fa-solid fa-plus"></i>&nbsp;&nbsp;Add New Address</button>
                    </div>
                </div>
                <div *ngIf="addressExists">
                    <H2 style=" background-color: rgb(35, 24, 134);color: #fdfdfd;">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-house"></i>&nbsp;&nbsp;Address List</H2>
                    <ag-grid-angular style="height: 200px; margin:20px" 
                        [columnDefs]="addressColumnDefs" [rowData]="address_details"
                        [defaultColDef]="defaultColDef">
                    </ag-grid-angular>
                </div>
            </mat-tab>            
            <mat-tab label="Contacts"><br>
                <div style="text-align:right;" *ngIf="!phoneExists">
                    <div style="align-items: center; justify-content: center;">
                        <button mat-raised-button style=" background-color: rgb(35, 24, 134);color: #fdfdfd;" (click)="addPhone()">&nbsp;<i class="fa-solid fa-plus"></i>&nbsp;&nbsp;Add New Subcontact</button>
                    </div>
                </div>
                <div *ngIf="phoneExists">
                    <H2 style=" background-color: rgb(35, 24, 134);color: #fdfdfd;">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-address-card"></i>&nbsp;&nbsp;Contact List</H2>
                    <ag-grid-angular style="height: 200px; margin:20px"  
                        [columnDefs]="subcontactColumnDefs" [rowData]="subcontact_details"
                        [defaultColDef]="defaultColDef">
                    </ag-grid-angular>
                </div>        
                <div><br><br>
                    <div>                            
                        <form [formGroup]="appointmentContactForm">
                            <div>
                                <H2 style=" background-color: rgb(2, 110, 74);color: #fdfdfd; margin-left: 10px;">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-person"></i>&nbsp;&nbsp;Appointment Contact Person</H2>
                                <div style="display: grid; grid-template-columns: repeat(4, 250px); gap: 0px 10px;">
                                    <mat-form-field class="input-container">
                                        <mat-label>Name</mat-label>
                                        <input matInput type="string" formControlName="contact_uuid" hidden >   
                                        <input matInput type="string" formControlName="contact_profile_appointment_contact_uuid" hidden >                                           
                                        <input matInput formControlName="name">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Email</mat-label>
                                        <input matInput formControlName="email">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Phone Number</mat-label>
                                        <input matInput formControlName="phone_number">
                                    </mat-form-field>
                                    <mat-form-field class="input-container">
                                        <mat-label>Mobile</mat-label>
                                        <input matInput formControlName="mobile_number">
                                        </mat-form-field>
                                </div>
                                <div style="display: grid; grid-template-columns: repeat(3, 250px); gap: 0px 10px;">
                                    <button mat-raised-button style=" background-color: rgb(0, 255, 55); color: #000000;"  *ngIf="appointmentContactProfileExists"
                                     (click)="submitAppointmentForm()">Update Appointment Contact Info</button>                                
                                    <button mat-raised-button style=" background-color: rgb(255, 0, 0);color: #fdfdfd;"    *ngIf="!appointmentContactProfileExists"
                                     (click)="submitAppointmentForm()">Create New Appointment Contact Info</button>                                     
                                </div>                                
                            </div>
                        </form>
                    </div>
                </div>                               
            </mat-tab>            
            <mat-tab label="Operations Profile"><br>
                <form [formGroup]="operationsForm">
                    <div style="display: flex; flex-direction: column; justify-content: space-between; gap: 1em; overflow-x:scroll; overflow-y: scroll">
                        <div>
                            <H2 style=" background-color: rgb(2, 110, 74);color: #fdfdfd;">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-address-card"></i>&nbsp;&nbsp;Location Profile</H2>
                            <div style="display: grid; grid-template-columns: repeat(4, 300px); word-wrap: break-word" >
                                <mat-checkbox formControlName="loading_dock">
                                    Is there a loading dock?</mat-checkbox>
                                <mat-checkbox formControlName="tailgate">
                                    Are tailgates required?</mat-checkbox>
                                <mat-checkbox formControlName="ground_level">
                                    Off-load with forks at ground level </mat-checkbox>
                                <mat-checkbox formControlName="truck_space">
                                    Is space available for a 53ft truck to park/offload?</mat-checkbox>
                                <mat-checkbox formControlName="straight_truck">
                                    Is a straight truck required?</mat-checkbox>
                                <mat-checkbox formControlName="high_cost">
                                    Is this a downtown or high cost area?</mat-checkbox>
                                <mat-checkbox formControlName="convention_center">
                                    Is this a convention centre?</mat-checkbox>
                                <mat-checkbox formControlName="pop_up">
                                    Is this a pop-up store?</mat-checkbox>
                                <mat-checkbox formControlName="residential">
                                    Is this a private residence?</mat-checkbox>
                                <mat-checkbox formControlName="elevator_inside">
                                    Is an elevator involved?</mat-checkbox>
                                <mat-checkbox formControlName="delivery_inside">
                                    Does the freight need to be moved from the loading area to an inside
                                    location?</mat-checkbox>
                                <mat-checkbox formControlName="hallway_corner">
                                    Does the hallway have corners>?</mat-checkbox>
                            </div>
                        </div>
                        <div>
                            <div style="display:flex; flex-direction: row; gap: 200px 100px">
                                <div>
                                    <H2 style=" background-color: rgb(2, 110, 74);color: #fdfdfd;">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-calendar-days"></i>&nbsp;&nbsp;Operating Days</H2>
                                    <div style="display: grid; grid-template-columns: repeat(2, 200px);">
                                        <mat-checkbox formControlName="to_friday">Monday to Friday</mat-checkbox>
                                        <mat-checkbox formControlName="to_saturday">Monday to Saturday</mat-checkbox>
                                        <mat-checkbox formControlName="to_thursday">Monday to Thursday</mat-checkbox>
                                        <mat-checkbox formControlName="seven_days">7 Days a Week</mat-checkbox>
                                        <mat-checkbox formControlName="monday_only">Mondays ONLY</mat-checkbox>
                                        <mat-checkbox formControlName="tuesday_only">Tuesdays ONLY</mat-checkbox>
                                        <mat-checkbox formControlName="wednesday_only">Wednesdays ONLY</mat-checkbox>
                                        <mat-checkbox formControlName="thursday_only">Thursdays ONLY</mat-checkbox>
                                        <mat-checkbox formControlName="friday_only">Fridays ONLY</mat-checkbox>
                                    </div>
                                </div>
                                <div>
                                    <H2 style=" background-color: rgb(2, 110, 74);color: #fdfdfd;">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-clock"></i>&nbsp;&nbsp;Operating Hours</H2>
                                    <div style="display: grid; grid-template-columns: repeat(3, 250px); gap: 0px 10px;">
                                        <mat-checkbox formControlName="appointments">Are Appointments
                                            required?</mat-checkbox>
                                        <mat-checkbox formControlName="after_hours">Are after-hours
                                            accomodated?</mat-checkbox>
                                        <mat-checkbox formControlName="access_loading">Limited time access to
                                            loading/unloading area?</mat-checkbox>
                                        <mat-form-field>
                                            <mat-label>Default Appointment Start Time</mat-label>
                                            <input matInput type="time" formControlName="appointment_start">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Default Appointment End Time</mat-label>
                                            <input matInput type="time" formControlName="appointment_end">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Default Appointment Day</mat-label>
                                            <input matInput formControlName="appointment_day">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Opening Time</mat-label>
                                            <input matInput formControlName="opening_time">
                                        </mat-form-field>
                                        <mat-form-field>
                                            <mat-label>Closing Time</mat-label>
                                            <input matInput formControlName="closing_time">
                                            <input matInput type="string" formControlName="contact_uuid" hidden >   
                                            <input matInput type="string" formControlName="contact_profile_uuid" hidden >                                                
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div>
                                <div style="margin-bottom: 10px">
                                    <button mat-raised-button style=" background-color: rgb(0, 255, 55);color: #000000;"  *ngIf="operationsProfileExists"
                                        (click)="submitOperationsForm()">Update Changes</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <button mat-raised-button style=" background-color: rgb(255, 0, 0);color: #fdfdfd;" 
                                        *ngIf="!operationsProfileExists"
                                        (click)="submitOperationsForm()">Create New Operations Profile</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </mat-tab>
            <mat-tab label="Service Areas">
                <form [formGroup]="serviceAreaForm">                    
                    <div
                        style="display: flex; flex-direction: column; justify-content: space-between; gap: 1em; overflow-x:scroll; overflow-y: scroll">
                        <div>
                            <H2 style=" background-color: rgb(110, 2, 96);color: #fdfdfd; margin-left: 10px;">&nbsp;<i class="fa-solid fa-cart"></i>&nbsp;&nbsp; Market Areas</H2>
                            <div style="display:flex; flex-direction: row; gap: 100px 20px">
                                <div style="display: grid; grid-template-columns: repeat(3, 200px);">
                                    <mat-checkbox formControlName="interprovincial">Interprovincial</mat-checkbox>
                                    <mat-checkbox formControlName="intraprovincial">Intraprovincial</mat-checkbox>
                                    <mat-checkbox formControlName="canada_us_border">Canada US
                                        Crossborder</mat-checkbox>
                                    <mat-checkbox formControlName="interstate">Interstate</mat-checkbox>
                                    <mat-checkbox formControlName="intrastate">Intrastate</mat-checkbox>
                                </div>
                                <div style="display: grid; grid-template-columns: repeat(1, 200px); gap: 0px 10px;">
                                    <mat-form-field>
                                        <mat-label>Province</mat-label>
                                        <input matInput formControlName="operation_profile_province">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>State</mat-label>
                                        <input matInput formControlName="operation_profile_state">
                                    </mat-form-field>
                                </div>
                                <div>
                                    <div
                                        style="display: grid; grid-template-columns: repeat(4, 200px); word-wrap: break-word">
                                        <mat-checkbox formControlName="mexico_border">US
                                            Mexico Crossboarder</mat-checkbox>
                                        <mat-checkbox formControlName="canada_west">Canada West</mat-checkbox>
                                        <mat-checkbox formControlName="canada_central">Canada Central</mat-checkbox>
                                        <mat-checkbox formControlName="canada_east">Canada East</mat-checkbox>
                                        <mat-checkbox formControlName="usa_new_england">USA New England</mat-checkbox>
                                        <mat-checkbox formControlName="usa_mid_atlantic">USA Mid Atlantic</mat-checkbox>
                                        <mat-checkbox formControlName="usa_great_lakes">USA Great Lakes</mat-checkbox>
                                        <mat-checkbox formControlName="usa_mid_west">USA Mid-West</mat-checkbox>
                                        <mat-checkbox formControlName="usa_south_atlantic">USA South
                                            Atlantic</mat-checkbox>
                                        <mat-checkbox formControlName="usa_southeast">USA Southeast</mat-checkbox>
                                        <mat-checkbox formControlName="usa_south_central">USA South
                                            Central</mat-checkbox>
                                        <mat-checkbox formControlName="usa_mountain">USA Mountain</mat-checkbox>
                                        <mat-checkbox formControlName="usa_pacific">USA Pacific</mat-checkbox>
                                        <mat-checkbox formControlName="usa_far_pacific">USA Far Pacific</mat-checkbox>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div style="display:flex; flex-direction: row; gap: 100px 20px">
                                <div>
                                    <H2 style=" background-color: rgb(110, 2, 96);color: #fdfdfd; margin-left: 10px;">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-truck"></i>&nbsp;&nbsp; Transportation Requirements</H2>
                                    <div
                                        style="display: grid; grid-template-columns: repeat(4, 200px); word-wrap: break-word">
                                        <mat-checkbox formControlName="use_csa">CSA</mat-checkbox>
                                        <mat-checkbox formControlName="use_fast">FAST</mat-checkbox>
                                        <mat-checkbox formControlName="use_ace">ACE</mat-checkbox>
                                        <mat-checkbox formControlName="use_aci">ACI</mat-checkbox>
                                        <mat-checkbox formControlName="use_ct_pat">CT PAT</mat-checkbox>
                                        <mat-checkbox formControlName="use_can_bond">Canada BOND</mat-checkbox>
                                        <mat-checkbox formControlName="use_us_bond">US BOND</mat-checkbox>
                                        <mat-checkbox formControlName="use_hazmat">HAZMAT</mat-checkbox>
                                        <mat-checkbox formControlName="protect_freezing">Protect From
                                            Freezing</mat-checkbox>
                                        <mat-checkbox formControlName="heated">Heated</mat-checkbox>
                                        <mat-checkbox formControlName="refrigeration">Refrigeration</mat-checkbox>
                                        <mat-checkbox formControlName="use_food_grade">Food Grade</mat-checkbox>
                                    </div>
                                </div>
                                <div>
                                    <H2 style=" background-color: rgb(110, 2, 96);color: #fdfdfd; margin-left: 10px;">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-file-doc"></i>&nbsp;&nbsp; Documentation Requirements</H2>
                                    <div
                                        style="display: grid; grid-template-columns: repeat(4, 200px); word-wrap: break-word">
                                        <mat-checkbox formControlName="bol_shipping">Shipping BOL</mat-checkbox>
                                        <mat-checkbox formControlName="bol_invoice">Invoice BOL</mat-checkbox>
                                        <mat-checkbox formControlName="pod_invoice">Invoice POD</mat-checkbox>
                                        <mat-checkbox formControlName="purchase_order_number_invoice">Purchase Order
                                            Number</mat-checkbox>
                                        <mat-checkbox formControlName="rate_quote_copy">Rate Quote</mat-checkbox>
                                        <mat-checkbox formControlName="pick_up_reference_number">Pick-up
                                            Reference</mat-checkbox>
                                        <mat-checkbox formControlName="delivery_reference_number">Delivery
                                            Reference</mat-checkbox>
                                            <input matInput type="string" formControlName="contact_uuid" hidden >   
                                            <input matInput type="string" formControlName="contact_profile_uuid" hidden >                                                
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div>
                                <div style="margin-bottom: 10px">
                                    <button mat-raised-button style=" background-color: rgb(0, 255, 55);color: #000000;"  *ngIf="operationsProfileExists"
                                        (click)="submitServiceAreaForm()">Update Changes</button>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                    <button mat-raised-button style=" background-color: rgb(255, 0, 0);color: #fdfdfd;" 
                                        *ngIf="!operationsProfileExists"
                                        (click)="submitServiceAreaForm()">Create New Operations Profile</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </mat-tab>
            <mat-tab label="Service Rates">
                <div style="text-align:right;">
                    <div style="align-items: center; justify-content: center;">
                        <button mat-raised-button style=" background-color: rgb(35, 24, 134);color: #fdfdfd;" *ngIf="!carrierServiceExists" (click)="addService()">&nbsp;<i class="fa-solid fa-plus"></i>&nbsp;&nbsp;Add New Service</button>
                    </div>
                </div><br>                 
                <H2 style=" background-color: rgb(17, 1, 1);color: #fdfdfd; margin-left: 10px;">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-gear"></i>&nbsp;&nbsp; Services</H2>
                <ag-grid-angular style="height: 250px; margin:20px"  
                    [columnDefs]="serviceRatesColumnDefs" [rowData]="service_rates"
                    [defaultColDef]="defaultColDef">
                </ag-grid-angular>
            </mat-tab>
            <mat-tab label="Default Service Charges">                
                <div style="text-align:right;">
                    <div style="align-items: center; justify-content: center;">
                        <button mat-raised-button style=" background-color: rgb(35, 24, 134);color: #fdfdfd;" *ngIf="!serviceExists" (click)="addDefaultService()">&nbsp;<i class="fa-solid fa-plus"></i>&nbsp;&nbsp;Add New Default Service</button>
                    </div>
                </div><br>                  
                <H2 style=" background-color: rgb(17, 1, 1);color: #fdfdfd; margin-left: 10px;">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-gear"></i>&nbsp;&nbsp; Default Services</H2>
                <ag-grid-angular style="height: 250px; margin:20px"  
                    [columnDefs]="defaultServicesColumnDefs" [rowData]="contact_profile_default_services"
                    [defaultColDef]="defaultColDef">
                </ag-grid-angular>
            </mat-tab>

            <mat-tab label="Accounting Profile">
                <form [formGroup]="accountingForm">
                    <div
                        style="display: flex; flex-direction: column; justify-content: space-between; gap: 1em; overflow-x:scroll;">
                        <div>
                            <h2> Finance Tools </h2>
                            <div style="display:flex; flex-direction: row; gap: 0px 40px">
                                <div
                                    style="display: grid; grid-template-columns: repeat(3, 200px); gap: 0px 10px; word-wrap: break-word">
                                    <mat-checkbox formControlName="on_hold" value={{accounting_profile.on_hold}}>On
                                        Hold</mat-checkbox>
                                    <mat-form-field>
                                        <mat-label>Batch No</mat-label>
                                        <input matInput formControlName="ap_batch_number">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Accounting Code</mat-label>
                                        <input matInput formControlName="accounting_code">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Carrier Code</mat-label>
                                        <input matInput formControlName="carrier_code">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Payment Term</mat-label>
                                        <input matInput formControlName="payment_terms">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Fuel Surcharged</mat-label>
                                        <input matInput formControlName="fuel_surcharged">
                                    </mat-form-field>
                                </div>
                                <div
                                    style="display: grid; grid-template-columns: repeat(4, 200px); gap: 0px 10px; word-wrap: break-word">
                                    <mat-checkbox value={{accounting_profile.tax_applied}}
                                        formControlName="tax_applied">Tax
                                        Applied</mat-checkbox>
                                    <mat-checkbox [checked]="isChecked('ab_carbon_fuel_tax', 'accounting_profile')"
                                        formControlName="ab_carbon_fuel_tax">Alberta Carbon Fuel Tax
                                        Applied</mat-checkbox>
                                    <mat-checkbox [checked]="isChecked('bc_carbon_fuel_tax', 'accounting_profile')"
                                        formControlName="bc_carbon_fuel_tax">BC Carbon Fuel Tax Applied</mat-checkbox>
                                    <mat-form-field>
                                        <mat-label>Tax Jurisdiction</mat-label>
                                        <input matInput formControlName="tax_jurisdiction">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Canada Tax ID</mat-label>
                                        <input matInput formControlName="can_tax_id">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>UFOS ACCPACC ID</mat-label>
                                        <input matInput formControlName="ufos_accpac_id">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Tax ID Number</mat-label>
                                        <input matInput formControlName="tax_id_number">
                                    </mat-form-field>
                                </div>
                            </div>
                            <div>
                                <div
                                    style="display: grid; grid-template-columns: repeat(9, 200px); gap: 0px 10px; word-wrap: break-word">
                                    <mat-form-field>
                                        <mat-label>Account Type</mat-label>
                                        <input matInput formControlName="account_type">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Account Currency</mat-label>
                                        <input matInput formControlName="account_currency">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Account Status</mat-label>
                                        <input matInput formControlName="account_status">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Account Note</mat-label>
                                        <input matInput formControlName="accounting_note">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Account Balance</mat-label>
                                        <input matInput formControlName="account_balance">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Account Balance Date</mat-label>
                                        <input matInput formControlName="account_balance_date">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Account Balance Days</mat-label>
                                        <input matInput formControlName="account_balance_days">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Credit Limit</mat-label>
                                        <input matInput formControlName="credit_limit">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Interest Rate</mat-label>
                                        <input matInput formControlName="interest_rate">
                                    </mat-form-field>
                                </div>
                            </div>
                        </div>
                        <div>
                            <h2> Invoice Details </h2>
                            <div style="display:flex; flex-direction: row; gap: 0px 40px">
                                <div
                                    style="display: grid; grid-template-columns: repeat(3, 200px); gap: 0px 10px; word-wrap: break-word">
                                    <mat-form-field>
                                        <mat-label>Report Group</mat-label>
                                        <input matInput formControlName="report_group">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Pay Term</mat-label>
                                        <input matInput formControlName="pay_term">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Billing Code</mat-label>
                                        <input matInput formControlName="billing_code">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Specify Time</mat-label>
                                        <input matInput formControlName="specify_time">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Customs Charges</mat-label>
                                        <input matInput formControlName="customs_charges">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Warehouse Charge</mat-label>
                                        <input matInput formControlName="warehouse_charge">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Freight Insurance</mat-label>
                                        <input matInput formControlName="freight_insurance">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Insurance Percentage</mat-label>
                                        <input matInput formControlName="insurance_percentage">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Insurance Minimum</mat-label>
                                        <input matInput formControlName="insurance_minimum">
                                    </mat-form-field>
                                </div>
                                <div
                                    style="display: grid; grid-template-columns: repeat(3, 200px); gap: 0px 10px; word-wrap: break-word">
                                    <mat-form-field>
                                        <mat-label>Pickup Rate</mat-label>
                                        <input matInput formControlName="pickup_rate">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Delivery Rate</mat-label>
                                        <input matInput formControlName="delivery_rate">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Hourly Rate</mat-label>
                                        <input matInput formControlName="hourly_rate">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Skid Fee</mat-label>
                                        <input matInput formControlName="skid_fee">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>DUNS Number</mat-label>
                                        <input matInput formControlName="duns_number">
                                    </mat-form-field>
                                    <mat-checkbox [checked]="isChecked('express_road', 'accounting_profile')"
                                        formControlName="express_road">Express Road</mat-checkbox>
                                    <mat-form-field>
                                        <mat-label>Invoice Comment</mat-label>
                                        <input matInput formControlName="invoice_comment">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Invoice Note</mat-label>
                                        <input matInput formControlName="invoice_note">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Default Cube Factor</mat-label>
                                        <input matInput formControlName="default_cube_factor">
                                    </mat-form-field>
                                </div>
                                <div style="display: flex; flex-direction: column; gap: 30px">
                                    <div style="align-items: center; justify-content: center;">
                                        <button mat-raised-button color="primary" [disabled]="!accountingProfileExists"
                                            (click)="submitAccountingForm()">Update
                                            Changes</button>
                                    </div>
                                    <div style="align-items: center; justify-content: center;">
                                        <button mat-raised-button color="primary"
                                            [disabled]="accountingProfileExists || accounting_profile_uuid !== ''"
                                            (click)="submitAccountingForm()">Create New Accounting Profile</button>
                                    </div>
                                </div>
                                <!-- <div style="align-items: center; justify-content: center;">
                                    <button mat-raised-button color="primary" (click)="submitAccountingForm()">Update</button>
                                </div> -->
                            </div>
                        </div>
                    </div>
                </form>
            </mat-tab>
            <!-- DOCUMENTS TAB -->
            <mat-tab label="Documents">

            <!-- DOCUMENT UPLOAD + DOCUMENT TABLE -->
            <div class="documents-section">
                <H2 style=" background-color: rgb(15, 32, 1);color: #fdfdfd; margin-left: 10px;">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-file-arrow-up"></i>&nbsp;&nbsp; Documents</H2>
                <br><br>
                <div
                class="document-drop-area"
                (dragover)="handleDocumentDragOver($event)"
                (dragleave)="handleDocumentDragLeave($event)"
                (drop)="handleDocumentDrop($event)"
                [ngClass]="{ 'dragging-over': isDraggingOverDocument }"
                >
                <p><span style="border-width:5px; border-style:dotted;; border-color:#FF0000; padding: 2em;"><i class="fas fa-upload"></i> Drag and drop files here to upload</span></p><br>
                </div>

                <h3 class="section-title">Documents</h3>

                <mat-table [dataSource]="documentsTable" class="mat-elevation-z8">

                <!-- FILE NAME -->
                <ng-container matColumnDef="file_name">
                    <mat-header-cell *matHeaderCellDef> File Name </mat-header-cell>
                    <mat-cell *matCellDef="let document"> {{ document.file_name }} </mat-cell>
                </ng-container>

                <!-- FILE TYPE -->
                <ng-container matColumnDef="file_type">
                    <mat-header-cell *matHeaderCellDef> File Type </mat-header-cell>
                    <mat-cell *matCellDef="let document"> {{ document.file_type }} </mat-cell>
                </ng-container>

                <!-- ACTIONS -->
                <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef> Actions </mat-header-cell>
                    <mat-cell *matCellDef="let document">

                    <!-- PDF (open in new tab) -->
                    <button mat-icon-button color="primary"
                            *ngIf="document.file_format.toLowerCase() === 'pdf'"
                            (click)="openDocument(document)">
                        <i class="fas fa-file-pdf"></i>
                    </button>

                    <!-- Word (open in new tab) -->
                    <button mat-icon-button color="primary"
                            *ngIf="document.file_format.toLowerCase() === 'doc'"
                            (click)="openDocument(document)">
                        <i class="fas fa-file-word"></i>
                    </button>

                    <!-- TIFF/TIF (download) -->
                    <button mat-icon-button color="primary"
                            *ngIf="['tif','tiff'].includes(document.file_format.toLowerCase())"
                            (click)="openDocument(document)">
                        <i class="fas fa-file-download"></i>
                    </button>

                    <!-- Images (open in modal) -->
                    <button mat-icon-button color="primary"
                            *ngIf="!['pdf','tif','tiff', 'doc'].includes(document.file_format.toLowerCase())"
                            (click)="openDocument(document)">
                        <i class="fas fa-image"></i>
                    </button>

                    <!-- Delete -->
                    <button mat-icon-button color="primary"
                            (click)="deleteDocument(document)">
                        <i class="fas fa-trash"></i>
                    </button>

                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>

                </mat-table>
            </div>
            </mat-tab>
            <!-- WSIB/W9 Form TAB -->
            <mat-tab label="WISB Forms">
                <form [formGroup]="wisbForm">
                    <div style="display: flex; flex-direction: column; justify-content: space-between; gap: 1em; overflow-x:scroll;">
                        <div>
                            <H2 style=" background-color: rgb(59, 7, 202);color: #fdfdfd; margin-left: 10px;">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-file"></i>&nbsp;&nbsp; WISB Form</H2>
                            <div style="display:flex; flex-direction: row; gap: 0px 40px">
                                <div
                                    style="display: grid; grid-template-columns: repeat(9, 250px); gap: 0px 10px; word-wrap: break-word">
                                    <mat-form-field>
                                        <mat-label>Legal Name</mat-label>
                                        <input matInput formControlName="legal_name">
                                        <input matInput type="string" formControlName="wisb_form_uuid" hidden >  
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Business Name</mat-label>
                                        <input matInput formControlName="business_name">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>US Tax ID Number</mat-label>
                                        <input matInput formControlName="us_taxpayer_id_no">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>WSIB/W9 Account Number</mat-label>
                                        <input matInput formControlName="wisb_account_no">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Other</mat-label>
                                        <input matInput formControlName="other">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Individual Proprietor</mat-label>
                                        <input matInput formControlName="individual_proprietor">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>C Corporation</mat-label>
                                        <input matInput formControlName="c_corporation">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>S Corporation</mat-label>
                                        <input matInput formControlName="s_corportation">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Partnership</mat-label>
                                        <input matInput formControlName="partnership">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Trust Estate</mat-label>
                                        <input matInput formControlName="trust_estate">
                                    </mat-form-field>                                                                                                                                                
                                    <mat-form-field>
                                        <mat-label>LLC LLP</mat-label>
                                        <input matInput formControlName="llc_llp">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Exempt Payee</mat-label>
                                        <input matInput formControlName="exempt_payee">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Address Street</mat-label>
                                        <input matInput formControlName="address_street">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Address Extended</mat-label>
                                        <input matInput formControlName="address_extended">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Address City</mat-label>
                                        <input matInput formControlName="address_locality">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Address Provice/State</mat-label>
                                        <input matInput formControlName="address_region">
                                    </mat-form-field>       
                                    <mat-form-field>
                                        <mat-label>Address Country</mat-label>
                                        <input matInput formControlName="address_country">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Adress Postal Code</mat-label>
                                        <input matInput formControlName="address_postal_code">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>WISB Certificate No</mat-label>
                                        <input matInput formControlName="wisb_certificate_no">
                                    </mat-form-field>     
                                    <mat-form-field>
                                        <mat-label>WISB Certificate Valid</mat-label>
                                        <input matInput formControlName="wisb_certificate_valid">
                                    </mat-form-field>                                                                                                  
                                </div>
                            </div>
                        </div>
                        <div>
                            <div style="display: flex; flex-direction: column; gap: 30px">
                                <div style="align-items: center; justify-content: center;">
                                    <button mat-raised-button style=" background-color: rgb(0, 255, 55);color: #000000;"  *ngIf="wisbFormExists"
                                        (click)="submitWISBForm()">Update
                                        Changes</button>
                                </div>
                                <div style="align-items: center; justify-content: center;">
                                    <button mat-raised-button style=" background-color: rgb(255, 0, 0);color: #fdfdfd;"  *ngIf="!wisbFormExists"
                                        (click)="submitWISBForm()">Create New WSIB Form</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </mat-tab>
            <!-- Insurance Form TAB -->
            <mat-tab label="Insurance Forms">
                <form [formGroup]="insuranceForm">
                    <div style="display: flex; flex-direction: column; justify-content: space-between; gap: 1em; overflow-x:scroll;">
                        <div>
                            <H2 style=" background-color: rgb(59, 7, 202);color: #fdfdfd; margin-left: 10px;">&nbsp;<i style="font-size: 30px;" class="fa-solid fa-file"></i>&nbsp;&nbsp; Insurance Form</H2>
                            <div style="display:flex; flex-direction: row; gap: 0px 40px">
                                <div
                                    style="display: grid; grid-template-columns: repeat(9, 250px); gap: 0px 10px; word-wrap: break-word">
                                    <mat-form-field>
                                        <mat-label>Policy No</mat-label>
                                        <input matInput formControlName="policy_no">
                                        <input matInput type="string" formControlName="insurance_form_uuid" hidden >  
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>GL Expires</mat-label>
                                        <input matInput formControlName="gl_expires">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>GL Limit</mat-label>
                                        <input matInput formControlName="gl_limit">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Auto Expires</mat-label>
                                        <input matInput formControlName="auto_expires">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Auto Limit</mat-label>
                                        <input matInput formControlName="auto_limit">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Cargo Expires</mat-label>
                                        <input matInput formControlName="cargo_expires">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Cargo Limit</mat-label>
                                        <input matInput formControlName="cargo_limit">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>WC Expires</mat-label>
                                        <input matInput formControlName="wc_expires">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Insurance Agent Information</mat-label>
                                        <input matInput formControlName="insurance_agent_information">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Agent Phone</mat-label>
                                        <input matInput formControlName="agent_phone">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Agent Fax</mat-label>
                                        <input matInput formControlName="agent_fax">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Description</mat-label>
                                        <input matInput formControlName="description">
                                    </mat-form-field>       
                                    <mat-form-field>
                                        <mat-label>Agent Contact UUID</mat-label>
                                        <input matInput formControlName="agent_contact_uuid">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Agent Name</mat-label>
                                        <input matInput formControlName="agent_name">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Previous Theft Claim</mat-label>
                                        <input matInput formControlName="previous_theft_claim">
                                    </mat-form-field>     
                                    <mat-form-field>
                                        <mat-label>Computers</mat-label>
                                        <input matInput formControlName="computers">
                                    </mat-form-field>        
                                    <mat-form-field>
                                        <mat-label>Electronics</mat-label>
                                        <input matInput formControlName="electronics">
                                    </mat-form-field> 
                                    <mat-form-field>
                                        <mat-label>Liquor</mat-label>
                                        <input matInput formControlName="liguor">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Theft</mat-label>
                                        <input matInput formControlName="theft">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Insecure Yard</mat-label>
                                        <input matInput formControlName="unsecure_yard">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Other Exclusion</mat-label>
                                        <input matInput formControlName="other_exclusion">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Agent Email</mat-label>
                                        <input matInput formControlName="agent_email">
                                    </mat-form-field>
                                    <mat-form-field>
                                        <mat-label>Licensing</mat-label>
                                        <input matInput formControlName="licensing">
                                    </mat-form-field>                                                                                                                                                                                                                                                                                                                                                         
                                </div>
                            </div>
                        </div>
                        <div>
                            <div style="display: flex; flex-direction: column; gap: 30px">
                                <div style="align-items: center; justify-content: center;">
                                    <button mat-raised-button style=" background-color: rgb(0, 255, 55);color: #000000;"  *ngIf="insuranceFormExists"
                                        (click)="submitInsuranceForm()">Update
                                        Changes</button>
                                </div>
                                <div style="align-items: center; justify-content: center;">
                                    <button mat-raised-button style=" background-color: rgb(255, 0, 0);color: #fdfdfd;"  *ngIf="!insuranceFormExists"
                                        (click)="submitInsuranceForm()">Create New Insurance Form</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </mat-tab>


        </mat-tab-group>
    </div>

</ng-container>